import { c as _c } from "react/compiler-runtime";
import { SectionHeadline } from '@/components/SectionHeadline';
import { FAQs } from '@/components/seo';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@/components/links';
import React from 'react';
import { LINKS } from '@/constants/links';
import { CHRISTMAS_YEAR } from '@/constants/christmas';
export function Faqs() {
  const $ = _c(52);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["xmas"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("faq.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-12 px-0 lg:mb-16" anchorKey="faq.title" id="faq">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("faq.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("faq.items.1.text", {
      from: CHRISTMAS_YEAR,
      to: CHRISTMAS_YEAR + 1
    });
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      question: t3,
      answer: t4
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("faq.items.2.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link testId="faqRegistration" analyticsParam="faqRegistration" to={LINKS().registration} />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = <Trans t={t} i18nKey="faq.items.2.text">{t7}</Trans>;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = {
      question: t6,
      answer: t8
    };
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("faq.items.3.title");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("faq.items.3.text");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = {
      question: t10,
      answer: t11
    };
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("faq.items.4.title");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Link testId="faqPackages" analyticsParam="faqPackages" to={LINKS().revolving} />;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = <Trans t={t} i18nKey="faq.items.4.text">{t14}</Trans>;
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t15) {
    t16 = {
      question: t13,
      answer: t15
    };
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t) {
    t17 = t("faq.items.5.title");
    $[35] = t;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link testId="faqPostponeDueDate" analyticsParam="faqPostponeDueDate" to={`${LINKS().postponeDueDate}#posunuti-zdarma`} />;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = <Trans t={t} i18nKey="faq.items.5.text">{t18}</Trans>;
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t17 || $[41] !== t19) {
    t20 = {
      question: t17,
      answer: t19
    };
    $[40] = t17;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t12 || $[44] !== t16 || $[45] !== t20 || $[46] !== t5 || $[47] !== t9) {
    t21 = <FAQs hideButton={true} className="m-0!" bgColor="bg-blue-50" data={[t5, t9, t12, t16, t20]} />;
    $[43] = t12;
    $[44] = t16;
    $[45] = t20;
    $[46] = t5;
    $[47] = t9;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t2 || $[50] !== t21) {
    t22 = <div className="mx-auto max-w-192 px-4 lg:px-0">{t2}{t21}</div>;
    $[49] = t2;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  return t22;
}